import { CompanyType } from "@/v1/types";

/**
 * Which FsE form a Mandant's Rechtsform (companyType) opens.
 *
 * ELSTER has a separate Datenart per legal form, and transmitting the wrong one
 * is only discovered by the Finanzamt. So the form follows the Rechtsform master
 * data rather than an operator picking it, and anything without a built form
 * opens nothing at all instead of falling back to another form.
 *
 * EUN covers the Einzelunternehmer (FsE_EUN), KAPG the Kapitalgesellschaften
 * GmbH and UG (FsE_KapG, SMT-1294). PersG comes later, which is why the
 * Personengesellschaften still resolve to `undefined` here.
 */
export type FseFormKind = "EUN" | "KAPG";

const FSE_FORM_BY_COMPANY_TYPE: Partial<Record<CompanyType, FseFormKind>> = {
  [CompanyType.EINZELUNTERNEHMER]: "EUN",
  [CompanyType.GMBH]: "KAPG",
  [CompanyType.UG]: "KAPG",
};

/**
 * Returns the form to render, or `undefined` when the Rechtsform is missing or
 * has no form yet. `undefined` always means "show the hint", never a fallback
 * to one of the built forms.
 */
export const getFseFormKind = (
  companyType?: CompanyType | null
): FseFormKind | undefined =>
  companyType ? FSE_FORM_BY_COMPANY_TYPE[companyType] : undefined;
